import {
  CdkDragDrop,
  DragDropConfig,
  moveItemInArray,
} from "@angular/cdk/drag-drop";
import {
  Component,
  EventEmitter,
  InjectionToken,
  Input,
  Output,
} from "@angular/core";

@Component({
  selector: "external-mam-customize-table",
  templateUrl: `./external-mam-customize-table.component.html`,
  styleUrls: ["./external-mam-customize-table.component.scss"],
})
export class ExternalMAMCustomizeTableComponent {
  @Input()
  columns: Array<customizeColumnDef> = [];

  @Output()
  onExit: EventEmitter<Array<customizeColumnDef>> = new EventEmitter();

  vm: Array<customizeColumnDef>;

  ngOnInit() {
    this.vm = [...this.columns];
  }

  justClose() {
    this.onExit.emit(null);
  }
  apply() {
    this.onExit.emit(this.vm);
  }

  selectAll() {
    this.vm.forEach((col) => {
      col.visible = true;
    });
  }
  clear() {
    this.vm.forEach((col) => {
      col.visible = false;
    });
  }

  drop(event: CdkDragDrop<customizeColumnDef[], customizeColumnDef[], customizeColumnDef>) {
    moveItemInArray(this.vm, event.previousIndex, event.currentIndex);
  }
}

export type customizeColumnDef = {
  columnName: string;
  visible: boolean;
};
